import { useRouter } from 'next/router';
import { useContext, useEffect, useState } from 'react';
import { Presenter } from 'src/components/shared/modal/DiscountNoticeModal/Presenter';
import { useCartAdd } from 'src/hooks/useCartAdd';
import { useModal } from 'src/hooks/useModal';
import type { Product } from 'src/models/product/schema';
import { I18nContext } from 'src/stores/I18n';
import { mixpanel } from 'src/utils/mixpanel';

export const DiscountNoticeModal = () => {
  const { isVisible, setIsVisible, modalParams, setModalParams } = useModal('discountNoticeModal');
  const [product, setProduct] = useState<Product | undefined>(undefined);
  const [quantity, setQuantity] = useState<number | undefined>(undefined);
  const localeResources = useContext(I18nContext);
  const { onAddToCart } = useCartAdd({ targetAttributionToken: modalParams.extraData?.targetAttributionToken });
  const { locale } = useRouter();

  useEffect(() => {
    if (product && quantity) {
      onAddToCart(product, quantity, 'discount_notice_modal');
      setProduct(undefined);
      setQuantity(undefined);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [product, quantity]);

  const handleAddCartButtonClick = () => {
    if (modalParams.product && modalParams.quantity) {
      setProduct(modalParams.product);
      setQuantity(modalParams.quantity);
      setModalParams({
        type: 'info'
      });
    }
    mixpanel.track('AddedToCartFromDiscountNotice', { type: 'PharmaceuticalProduct' });
    setIsVisible(false);
  };

  const closeModal = () => {
    setModalParams({
      type: 'info'
    });
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <Presenter
      product={modalParams.product as Product}
      localeResources={localeResources}
      onAddCartButtonClick={handleAddCartButtonClick}
      closeModal={closeModal}
      locale={locale}
    />
  );
};
